import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import { Field, Formik, Form } from 'formik';
import FormikFieldInputGroup from '../../../../components/form/formik/FormikFieldInputGroup';
import { WriteOffButton } from '../../../../components/buttons/WriteOffButton';
import * as Yup from 'yup';
import { CancelButton } from '../../../../components/buttons/CancelButton';
import './WriteOffModal.css';
import { FormikDateTimePickerGroup } from '../../../../components/form/formik/FormikDateTimePickerGroup';
import { DEFAULT_DATE } from '../../../../components/common/Constants';

const WriteOffModal = ({ obj, onClick, disabled }) => {
    const [show, setShow] = useState(false);
    const { t } = useTranslation('warehouse');
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleWriteOff = (values) => {
        onClick(obj, values.writeOff, values.writeOffDay);
        handleClose();
    };

    const validation = Yup.object().shape({
        writeOffDay: Yup.string()
            .transform(value => (value === null ? '' : value))
            .required(t('validations:required')),
        writeOff: Yup.number()
            .required(t('validations:required'))
            .min(0.001, t('validations:higherThan') + 0.001)
            .max(obj.amount, t('validations:maxInputNumber') + obj.amount),
    });

    const writeOffAllAmount = (values) => {
        onClick(obj, obj.amount, values.writeOffDay);
        handleClose();
    };

    return (
        <>
            <WriteOffButton onClick={handleShow} disabled={disabled} />
            <Modal show={show} onHide={handleClose} backdrop='static'>
                <Modal.Header closeButton>
                    <Modal.Title>{obj.productName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>
                        {t('amount')}
                        {': ' + obj.amount + ' kg'}
                    </h4>
                    <Formik
                        initialValues={{ writeOff: '', writeOffDay: '' }}
                        enableReinitialize
                        onSubmit={(values) => handleWriteOff(values)}
                        validationSchema={validation}
                    >
                        {({ values }) => {
                            return (
                                <Form>
                                    <Field
                                        key='write-off-date'
                                        className='mb-3'
                                        name='writeOffDay'
                                        labelText={t('writeOffDay')}
                                        type={'datePicker'}
                                        data={{
                                            dateFormat: DEFAULT_DATE,
                                            showTime: false,
                                        }}
                                        component={FormikDateTimePickerGroup}
                                    />
                                    <Field
                                        key='writeOff'
                                        className='mb-3'
                                        name='writeOff'
                                        labelText={t('writeOff') + ' kg'}
                                        type='number'
                                        component={FormikFieldInputGroup}
                                    />
                                    <div className={'buttons--container'}>
                                        <div>
                                            <CancelButton
                                                variant='secondary'
                                                onClick={handleClose}
                                                className='button'>
                                                {t('common:buttons.cancel')}
                                            </CancelButton>
                                            <WriteOffButton
                                                variant='primary'
                                                type='submit'
                                                className='button'>
                                            </WriteOffButton>
                                        </div>
                                        <button className={'button--main primary-button'}
                                                type={'button'}
                                                onClick={() => writeOffAllAmount(values)}
                                                disabled={values.writeOffDay === null || values.writeOffDay === ''}>
                                            {t('common:buttons.writeOffAll')}
                                        </button>
                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default WriteOffModal;
